export default "__VITE_ASSET__CB50DGMx__"